import { render, staticRenderFns } from "./CRUDMotivos.vue?vue&type=template&id=3851fad7&"
import script from "./CRUDMotivos.vue?vue&type=script&lang=js&"
export * from "./CRUDMotivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports